import { TitleButtonDivider } from '@/common/buttons/TitleButtonDivider';
import { EntityPerspective } from '@/common/entityFramework/entityPerspective/EntityPerspective';
import { RowIcon } from '@/common/entityFramework/entityPerspective/support/RowIcon';
import { fas } from '@awesome.me/kit-b4fd369ea4/icons';
import { useCallback, useRef } from 'react';
import { TheraSelect } from '../../theraSelect/TheraSelect';

export const AbvSapActualsPerspective = () => {
  const entityPerspectiveRef = useRef();
  const theraSelectRef = useRef();

  const views = [
    {
      name: 'Balances',
      dims: ['PAID_PERIOD', 'CHANNEL', 'COMPANY_CODE', 'GL_ACCT_TYPE'],
      kpis: ['START_BAL', 'AUTO_ACCR_AMT', 'MAN_ACCR_AMT', 'PIPE_AMT', 'TOTAL_ACCR', 'PYMT_AMT', 'END_BAL'],
      numFrozenDims: 1,
      dimToPeriodicities: {
        PAID_PERIOD: ['YEAR', 'QTR', 'MON'],
        EARNED_PERIOD: ['YEAR', 'QTR'],
      },
    },
  ];

  const rowIconsFn = (data) => {
    let rowIcons = [];

    if (data.closed) {
      rowIcons.push(<RowIcon key="closed" icon={fas.faCheckCircle} color="green" toolTip="Period is closed" />);
    }

    return rowIcons;
  };

  // TODO: Only show the accrual and payment items depending on the view
  const getContextMenuItems = (params) => {
    let contextMenus = entityPerspectiveRef.current.getContextMenuItems(params);

    const accrItems = [
      {
        name: 'Auto Accruals',
        action: () => entityPerspectiveRef.current.navigateToViewer(params, 'AUTO_ACCR_AMT', 'Auto Accruals'),
        icon: fas.faListUl,
      },
      {
        name: 'Pivot Auto Accruals',
        action: () => entityPerspectiveRef.current.navigateToPivot(params, 'AUTO_ACCR_AMT', 'Auto Accruals'),
        icon: fas.faTableColumns,
      },
      {
        name: 'Manual Accruals',
        action: () => entityPerspectiveRef.current.navigateToViewer(params, 'MAN_ACCR_AMT', 'Manual Accruals'),
        icon: fas.faListUl,
      },
      {
        name: 'Pivot Manual Accruals',
        action: () => entityPerspectiveRef.current.navigateToPivot(params, 'MAN_ACCR_AMT', 'Manual Accruals'),
        icon: fas.faTableColumns,
      },
      {
        name: 'Pipeline Adjustments',
        action: () => entityPerspectiveRef.current.navigateToViewer(params, 'PIPE_AMT', 'Pipeline Adjustments'),
        icon: fas.faListUl,
      },
      {
        name: 'Pivot Pipeline Adjustments',
        action: () => entityPerspectiveRef.current.navigateToPivot(params, 'PIPE_AMT', 'Pipeline Adjustments'),
        icon: fas.faTableColumns,
      },
    ];

    const pymtItems = [
      {
        name: 'Payments',
        action: () => entityPerspectiveRef.current.navigateToViewer(params, 'PYMT_AMT', 'Payment Amounts'),
        icon: fas.faListUl,
      },
      {
        name: 'Pivot Payments',
        action: () => entityPerspectiveRef.current.navigateToPivot(params, 'PYMT_AMT', 'Payment Amounts'),
        icon: fas.faTableColumns,
      },
    ];

    contextMenus.push(
      {
        name: 'Start Balances',
        action: () => entityPerspectiveRef.current.navigateToViewer(params, 'START_BAL', 'Start Balances'),
        icon: fas.faListUl,
      },
      {
        name: 'Accrual Transaction Details',
        subMenu: accrItems,
        icon: fas.faListUl,
      },
      {
        name: 'Payment Transaction Details',
        subMenu: pymtItems,
        icon: fas.faListUl,
      },
      {
        name: 'Export',
        action: () => entityPerspectiveRef.current.openExportDialog(params),
        icon: fas.faArrowCircleDown,
      },
    );

    return contextMenus;
  };

  const handleViewReset = useCallback(() => {
    theraSelectRef.current.reset();
  }, []);

  const events = {
    onDimFilterChange: ({ dimCode }) => {
      if (dimCode === 'PROD') {
        theraSelectRef.current.reset();
      }
    },
  };
  const augButtons = (buttons) => {
    buttons.push(
      <TheraSelect entityPerspectiveRef={entityPerspectiveRef} ref={theraSelectRef} />,
      <TitleButtonDivider key="filterButtonDivider" />,
    );
  };

  return (
    <EntityPerspective
      ref={entityPerspectiveRef}
      views={views}
      rowIconsFn={rowIconsFn}
      augButtons={augButtons}
      onViewReset={handleViewReset}
      events={events}
      gridOptions={{
        getContextMenuItems,
      }}
    />
  );
};
